<template>
    <v-footer app height="auto" color="#7c7c7c" dark inset>
        <v-layout align-center justify-space-between row warp>
            <v-flex :class="{md4 : $vuetify.breakpoint.mdAndUp, xs12 : $vuetify.breakpoint.smAndDown}">
                <label>
                    UBehave by NStart Software
                </label>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex :class="{md4 : $vuetify.breakpoint.mdAndUp, xs12 : $vuetify.breakpoint.smAndDown}" dark>
                <slot></slot>
                <v-flex>
                    <v-btn   v-for="(icon, index) in icons"
                             :key="index"
                             :href="icon.url"
                             :target="icon.target"
                             class="mx-3"
                             icon
                             small
                    >
                        <v-icon>
                            {{ icon.name }}
                        </v-icon>
                    </v-btn>
                </v-flex>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex :class="{md4 : $vuetify.breakpoint.mdAndUp, xs12 : $vuetify.breakpoint.smAndDown}">
                <label>&copy;{{new Date().getFullYear()}} NStart Software, LLC. All Rights Reserved.</label>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
    export default {
        name: "FooterView",
        data(){
            return{
                icons: [
                    {
                        name:'fab fa-twitter',
                        url: 'https://twitter.com/NStartSoftware/',
                        target: '_blank'
                    },
                    {
                        name:'fab fa-linkedin',
                        url: 'https://www.linkedin.com/company/nstartsoftware/',
                        target: '_blank'
                    },
                    {
                        name:'fab fa-facebook-f',
                        url: 'https://www.facebook.com/NStartSoft/',
                        target: '_blank'
                    },
                    {
                        name:'fab fa-instagram',
                        url: 'https://www.instagram.com/NStartSoftware/',
                        target: '_blank'
                    }
                ]
            }
        }
    }
</script>

<style scoped>

</style>